export default "__VITE_ASSET__CevPuScP__"